var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "width50 padding-right-20 outlookOverview scrollBox highlights--results hideMobile",
    },
    [
      _c(
        "h3",
        {
          staticClass:
            "hl-module text-color--primary-contrast margin-top-15 margin-bottom-10 margin-left-20",
        },
        [_vm._v("\n        " + _vm._s(_vm.marketName) + "\n    ")]
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "h3 margin-bottom-2 margin-left-20" }, [
        _vm._v("\n        " + _vm._s(_vm.market) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "margin-bottom-15 margin-left-20" }, [
        _c("p", { staticClass: "margin-bottom-2" }, [
          _vm._v("\n            " + _vm._s(_vm.description) + "\n        "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "margin-bottom-15 margin-left-20" }, [
        _c(
          "a",
          {
            staticClass: "linkArrowHover margin-top-20",
            attrs: {
              href: _vm.marketLink,
              "data-gtm": _vm.gtm,
              tabindex: "-1",
            },
          },
          [
            _c(
              "svg",
              {
                staticClass: "stat__svgIcon",
                attrs: { "aria-hidden": "true" },
              },
              [_c("use", { attrs: { href: "#iconArrowRightLongBold" } })]
            ),
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("XMO_HIGHLIGHTS_OUTLOOK_EXPLORE")) +
                "\n        "
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }